'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Right = require('./Right');

var _Right2 = _interopRequireDefault(_Right);

var _Left = require('./Left');

var _Left2 = _interopRequireDefault(_Left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { Left: _Left2.default, Right: _Right2.default };


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Angle/index.js
// module id = 98
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14